'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconMountainSun, iconMountainSunTag } from '@ni/nimble-components/dist/esm/icons/mountain-sun';
import { wrap } from '../../utilities/react-wrapper';

export type { IconMountainSun };
export { iconMountainSunTag };
export const NimbleIconMountainSun = wrap(IconMountainSun);